import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Input } from './Input';
import type { InputSize } from './Input';

export type SearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  size?: InputSize;
  className?: string;
  'aria-label'?: string;
  autoFocus?: boolean;
};

const iconSizeBySize: Record<InputSize, string> = {
  small: 'w-3.5 h-3.5',
  medium: 'w-4 h-4',
  large: 'w-4 h-4',
};

const paddingLeftBySize: Record<InputSize, string> = {
  small: '[&_input]:!pl-8',
  medium: '[&_input]:!pl-9',
  large: '[&_input]:!pl-10',
};

const iconLeftBySize: Record<InputSize, string> = {
  small: 'left-2.5',
  medium: 'left-3',
  large: 'left-3.5',
};

export function SearchInput({
  value,
  onChange,
  placeholder = 'Search...',
  size = 'medium',
  className = '',
  'aria-label': ariaLabel = 'Search',
  autoFocus,
}: SearchInputProps) {
  const hasValue = value.length > 0;
  return (
    <div className={`relative ${className}`}>
      <MagnifyingGlassIcon
        className={`absolute ${iconLeftBySize[size]} top-1/2 -translate-y-1/2 ${iconSizeBySize[size]} text-white/40 pointer-events-none z-10`}
      />
      <Input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        size={size}
        aria-label={ariaLabel}
        autoFocus={autoFocus}
        className={`${paddingLeftBySize[size]} ${hasValue ? '[&_input]:!pr-8' : ''}`}
      />
      {hasValue && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="Clear search"
          className="absolute right-1.5 top-1/2 -translate-y-1/2 z-10 inline-flex items-center justify-center w-5 h-5 rounded-full text-white/50 hover:text-white hover:bg-white/10 transition-colors"
        >
          <XMarkIcon className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
}

export default SearchInput;
